import {
  type CreateSegmentMutation,
  type CreateSegmentMutationVariables,
  type FlagsAdminV1SegmentInput,
  type SegmentFragment,
  useCreateSegmentMutation,
  withStandardCreateHook,
} from '@spotify/confidence-graphql';

export const useCreateSegment = withStandardCreateHook<
  CreateSegmentMutation,
  SegmentFragment,
  'createSegment',
  CreateSegmentMutationVariables,
  [FlagsAdminV1SegmentInput]
>(
  useCreateSegmentMutation,
  'createSegment',
  (input: FlagsAdminV1SegmentInput) => ({ segment: input }),
);
